import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'
import { Form } from 'factorial-form'

import FormComponent from 'modules/core/components/Form'
import { Panes } from 'modules/core/components/Panes'
import PanesHeader from 'modules/core/components/PanesHeader'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import app from 'modules/core/store/models/app'

import { MAX_REGULAR_ACCESS_DELAY_DAYS } from 'modules/employees/lib/constants'

import ContainerComponent from './ContainerComponent'
import HeaderComponent from './HeaderComponent'

class CreateCompanyForm extends Form {
  constructor(values: {}) {
    super(values, {
      regular_access_delay_in_days: 'number',
    })
  }
}

const DATE_TYPES = {
  contractStartDate: 'contract_start_date',
  customDate: 'custom_date',
}

const DefaultEndDate = () => {
  const [inputValue, setInputValue] = React.useState<number>(
    companies.current.attributes.regular_access_delay_in_days
  )
  const defaultOption =
    companies.current.attributes.regular_access_delay_in_days === 0
      ? DATE_TYPES.contractStartDate
      : DATE_TYPES.customDate
  const [selectedOption, setSelectedOption] = React.useState<string>(defaultOption)
  const form = React.useRef(new CreateCompanyForm(companies.current.toJS())).current

  const handleOnChangeCustomDate = (days: number) => {
    setInputValue(days || 0)
    form
      .get('regular_access_delay_in_days')
      .setErrors(
        days > MAX_REGULAR_ACCESS_DELAY_DAYS
          ? [
              i18n.t(
                'app_store_v2.apps.employee_onboarding.settings_default_date.custom_date_error'
              ),
            ]
          : null
      )
  }

  const onSubmit = async () => {
    const value =
      selectedOption === DATE_TYPES.contractStartDate
        ? 0
        : form.get('regular_access_delay_in_days').value

    const { success } = await asyncAction(() =>
      companies.current.save({
        regular_access_delay_in_days: value,
      })
    )

    if (!success) {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_saving'),
      })
    }
  }

  return (
    <Panes direction="horizontal" type="naked">
      <PanesHeader
        description={i18n.t(
          'app_store_v2.apps.employee_onboarding.settings_default_date.description'
        )}
        illustration="calendar-clock"
        line
        title={i18n.t('app_store_v2.apps.employee_onboarding.settings_default_date.title')}
      />
      <Box paddingTop="s48">
        <FormComponent onSubmit={onSubmit}>
          <Box gap="s24">
            <ContainerComponent
              header={
                <HeaderComponent
                  label={i18n.t(
                    'app_store_v2.apps.employee_onboarding.settings_default_date.contract_start_date'
                  )}
                  onClick={() => setSelectedOption(DATE_TYPES.contractStartDate)}
                  checked={selectedOption === DATE_TYPES.contractStartDate}
                  text={i18n.t(
                    'app_store_v2.apps.employee_onboarding.settings_default_date.contract_start_date_text'
                  )}
                />
              }
              open={false}
            />
            <ContainerComponent
              header={
                <HeaderComponent
                  label={i18n.t(
                    'app_store_v2.apps.employee_onboarding.settings_default_date.custom_date'
                  )}
                  onClick={() => setSelectedOption(DATE_TYPES.customDate)}
                  checked={selectedOption === DATE_TYPES.customDate}
                  text={i18n.t(
                    'app_store_v2.apps.employee_onboarding.settings_default_date.custom_date_text'
                  )}
                />
              }
              open={selectedOption === DATE_TYPES.customDate}
              field={form.get('regular_access_delay_in_days')}
              value={inputValue.toString()}
              onChange={(e: Field) => handleOnChangeCustomDate(parseInt(e.value))}
            />
            <Button disabled={!!form.hasErrors} submit>
              {i18n.t('common.submit')}
            </Button>
          </Box>
        </FormComponent>
      </Box>
    </Panes>
  )
}

export default DefaultEndDate
